import AnalyticsCard from './AnalyticsCard.component';

export default AnalyticsCard;
